import {
  SegmentListPage,
  SegmentEditPage,
  IndustryListPage,
  IndustryEditPage,
  SegmentCreatePage,
  LifeCycleListPage,
  LifeCycleEditPage,
  IndustryCreatePage,
  LifeCycleCreatePage,
  ChurnReasonListPage,
  ChurnReasonEditPage,
  ContactTypeListPage,
  ContactTypeEditPage,
  DocumentTypeListPage,
  DocumentTypeEditPage,
  ChurnReasonCreatePage,
  ContactTypeCreatePage,
  DocumentTypeCreatePage,
} from './imports';

export const companyRoutes = [
  {
    path: 'companies',
    children: [
      { element: <IndustryListPage />, index: true },
      { path: 'list', element: <IndustryListPage /> },
      { path: ':id/edit', element: <IndustryEditPage /> },
      { path: 'new', element: <IndustryCreatePage /> },
      {
        path: 'segments',
        children: [
          { element: <SegmentListPage />, index: true },
          { path: 'list', element: <SegmentListPage /> },
          { path: ':id/edit', element: <SegmentEditPage /> },
          { path: 'new', element: <SegmentCreatePage /> },
        ],
      },
      {
        path: 'life-cycles',
        children: [
          { element: <LifeCycleListPage />, index: true },
          { path: 'list', element: <LifeCycleListPage /> },
          { path: 'new', element: <LifeCycleCreatePage /> },
          { path: ':id/edit', element: <LifeCycleEditPage /> },
        ],
      },
      {
        path: 'churn-reasons',
        children: [
          { element: <ChurnReasonListPage />, index: true },
          { path: 'list', element: <ChurnReasonListPage /> },
          { path: 'new', element: <ChurnReasonCreatePage /> },
          { path: ':id/edit', element: <ChurnReasonEditPage /> },
        ],
      },
      {
        path: 'document-types',
        children: [
          { element: <DocumentTypeListPage />, index: true },
          { path: 'list', element: <DocumentTypeListPage /> },
          { path: 'new', element: <DocumentTypeCreatePage /> },
          { path: ':id/edit', element: <DocumentTypeEditPage /> },
        ],
      },
      {
        path: 'contact-types',
        children: [
          { element: <ContactTypeListPage />, index: true },
          { path: 'list', element: <ContactTypeListPage /> },
          { path: 'new', element: <ContactTypeCreatePage /> },
          { path: ':id/edit', element: <ContactTypeEditPage /> },
        ],
      },
    ],
  },
];
